import Icon from "components/icon";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Colors } from "theme/colors";

export const StyledWrapper = styled.div`
  position: relative;
`;

export interface OptionInterface {
  value: string;
  text: string;
  disabled?: boolean;
}

interface TextProps {
  $disabled: boolean;
  $empty: boolean;
  $hover: boolean;
  $focus: boolean;
}

export const StyledText = styled.div<TextProps>`
  border-radius: 0.325rem;
  width: 100%;
  outline: none;
  font-size: 0.9375rem;
  height: 2.47rem;

  // color
  color: ${Colors.TEXT_GRAY};
  ${(props) =>
    props.$disabled &&
    css`
      color: ${Colors.DARK_GRAY};
    `}

  // special case: empty
  ${(props) =>
    props.$empty &&
    css`
      color: ${Colors.DARK_GRAY};
    `}

  // padding
  padding: 0.725rem 1rem 0.625rem 1rem;

  // border
  border: 0.059rem solid ${Colors.MID_GRAY};

  // background
  background-color: ${Colors.WHITE};
  ${(props) =>
    props.$disabled &&
    css`
      background-color: ${Colors.LIGHT_GRAY};
    `}

  // hover styles
  ${(props) =>
    props.$hover &&
    css`
      background-color: ${Colors.LIGHT_GRAY};
    `}

  // focus tyles
  ${(props) =>
    props.$focus &&
    css`
      padding: calc(0.725rem - 0.18rem) calc(1rem - 0.18rem);
      border: 0.18rem solid ${Colors.MID_BLUE};
      background-color: ${Colors.WHITE};
    `}

  // box-shadow
  box-shadow: 0 0.294rem 0.59rem 0 rgba(0, 0, 0, 0.2) inset;
`;

export const StyledInner = styled.div`
  position: absolute;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: calc(100% - 2.94rem);
`;

export const StyledArrow = styled(Icon)`
  position: absolute;
  top: 0.7rem;
  right: 1.06rem;
  pointer-events: none;
`;

export const StyledLock = styled(Icon)`
  position: absolute;
  top: 0.7rem;
  right: 1.06rem;
  pointer-events: none;
`;

export const StyledDropdown = styled.select`
  width: 100%;
  height: 2.47rem;
  opacity: 0;
  top: 0;
  cursor: pointer;

  display: block;
  position: absolute;

  &:disabled {
    cursor: default;
  }
`;
